export default {"src":"/_next/static/media/pending.3aa8fcae.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};